import { IconBrandInstagram, IconShoppingBag } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { useCart } from "~/context/CartContext";
import SliderCart from "./Storefront/SliderCart";

export default function Navbar({ isAdmin }: { isAdmin?: boolean }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const { cart, cartOpen, setCartOpen } = useCart();

  useEffect(() => {
    if(menuOpen){
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [menuOpen]);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 ${
        menuOpen ? "bg-[#d9d9d9]" : cartOpen ? "bg-white" : "bg-white/70"
      } md:bg-white/70 transition-colors duration-200 backdrop-blur-md shadow-md`}
    >
      {/* Skip to content (visually hidden except for screen readers) */}
      <a href="#page" className="sr-only focus:not-sr-only">
        Skip to Content
      </a>

      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Left side: Logo */}
          <div className="flex items-center">
            {/* Logo */}
            <a href="/" className="flex items-center">
              <img
                src="/images/logo-combined.svg"
                alt="Veneration Wear"
                className="h-14 md:h-10 lg:h-14 w-auto"
              />
            </a>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden md:flex md:space-x-6 lg:space-x-8">
            {/* About Folder */}
            <div className="relative group">
              <button className="hover:text-gray-600 transition-colors py-2 ">
                About
              </button>
              {/* Dropdown for About VW */}
              <div className="absolute left-0 top-9 hidden group-hover:block bg-white shadow-lg border border-gray-200">
                <ul className="flex flex-col w-60">
                  <li>
                    <a
                      href="/contact-us"
                      className="block px-4 py-2 hover:bg-gray-50"
                    >
                      Contact Us
                    </a>
                  </li>
                  <li>
                    <a
                      href="/faqs"
                      className="block px-4 py-2 hover:bg-gray-50"
                    >
                      FAQs
                    </a>
                  </li>
                  <li>
                    <a
                      href="/privacy-policy"
                      className="block px-4 py-2 hover:bg-gray-50"
                    >
                      Privacy Policy
                    </a>
                  </li>
                  <li>
                    <a
                      href="/shipping-and-returns"
                      className="block px-4 py-2 hover:bg-gray-50"
                    >
                      Shipping and Returns
                    </a>
                  </li>
                  <li>
                    <a
                      href="/terms-of-service"
                      className="block px-4 py-2 hover:bg-gray-50"
                    >
                      Terms Of Service
                    </a>
                  </li>
                  <li>
                    <a
                      href="/veneration-wear-agreement"
                      className="block px-4 py-2 hover:bg-gray-50"
                    >
                      Veneration Wear Agreement
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Athletes Folder */}
            <div className="relative group">
              <button className="py-2 hover:text-gray-600 transition-colors">
                Athletes
              </button>
              <div className="absolute left-0 top-9 hidden group-hover:block bg-white shadow-lg border border-gray-200">
                <ul className="flex flex-col w-60">
                  <li>
                    <a
                      href="/athletes"
                      className="block px-4 py-2 hover:bg-gray-50"
                    >
                      Veneration Athletes
                    </a>
                  </li>
                  <li>
                    <a
                      href="/become-an-athlete"
                      className="block px-4 py-2 hover:bg-gray-50"
                    >
                      Become A Veneration Athlete
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Businesses Folder */}
            <div className="relative group">
              <button className="py-2 hover:text-gray-600 transition-colors">
                Businesses
              </button>
              <div className="absolute left-0 top-9 hidden group-hover:block bg-white shadow-lg border border-gray-200">
                <ul className="flex flex-col w-60">
                  <li>
                    <a
                      href="/businesses"
                      className="block px-4 py-2 hover:bg-gray-50"
                    >
                      Veneration Businesses
                    </a>
                  </li>
                  <li>
                    <a
                      href="/become-a-business"
                      className="block px-4 py-2 hover:bg-gray-50"
                    >
                      Become A Veneration Business
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Creators Folder */}
            <div className="relative group">
              <button className="py-2 hover:text-gray-600 transition-colors">
                Creators
              </button>
              <div className="absolute left-0 top-9 hidden group-hover:block bg-white shadow-lg border border-gray-200">
                <ul className="flex flex-col w-60">
                  <li>
                    <a
                      href="/creators"
                      className="block px-4 py-2 hover:bg-gray-50"
                    >
                      Veneration Creators
                    </a>
                  </li>
                  <li>
                    <a
                      href="/become-a-creator"
                      className="block px-4 py-2 hover:bg-gray-50"
                    >
                      Become A Veneration Creator
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            
          </nav>

          {/* Right side icons + CTA */}
          <div className="flex items-center -translate-y-0.5">
            {/* Instagram */}
            <a
              href="http://instagram.com/venerationwear"
              target="_blank"
              rel="noreferrer"
              className="p-1 pt-1.5 m-1 hover:bg-gray-200 rounded text-black"
              aria-label="Instagram"
            >
              {/* Use your own SVG or icon library */}
              <IconBrandInstagram className="w-7 h-7" />
            </a>

            {/* Cart link */}
            <button
              type="button"
              className="relative p-1 m-1 hover:bg-gray-200 rounded mr-2"
              onClick={() => setCartOpen((prev: boolean) => !prev)}
              aria-label="Cart"
            >
              {/* Sample cart icon */}
              <IconShoppingBag className="w-7 h-7" />
              {/* Optional item count */}
              <span className="absolute top-0.5 right-0.5 bg-red-500 text-white text-xs rounded-full h-3.5 w-3.5 flex items-center justify-center">
                {cart?.totalQuantity || 0}
              </span>
            </button>

            <button
              className="mr-2 md:hidden rounded-lg header-burger-btn burger"
              onClick={() => setMenuOpen((prev) => !prev)}
              aria-label="Toggle Menu"
              data-test="header-burger"
            >
              <div className="burger-box ml-0.5">
                <div className="w-6 h-7 relative">
                  <div
                    className={`top-bun absolute h-0.5 w-5 block my-[14px] transition-transform bg-black ${
                      menuOpen
                        ? "-translate-x-[2px] -rotate-[135deg]"
                        : "-translate-y-[5.5px]"
                    }`}
                  ></div>
                  <div
                    className={`bottom-bun absolute h-0.5 w-5 block my-[14px] transition-transform bg-black ${
                      menuOpen
                        ? "-translate-x-[2px] rotate-[135deg]"
                        : "translate-y-[5.5px]"
                    }`}
                  ></div>
                </div>
              </div>
            </button>

            {/* CTA Button */}
            {!isAdmin && (
              <>
                <a
                  href="/create-a-collection"
                  className="hidden sm:inline-block bg-black text-white px-5 py-3 md:px-3 md:py-2 md:ml-2 md:whitespace-nowrap rounded-lg  hover:bg-gray-800"
                >
                  GET YOUR COLLECTION
                </a>

                <a href="/admin/login" className="hidden lg:block ml-4 hover:text-gray-600 transition-colors">Login</a>
              </>
            )}

            {isAdmin && (
              <>
                <a
                  href="/admin"
                  className="hidden sm:inline-block bg-black text-white px-5 py-3 md:px-3 md:py-2 md:ml-2 md:whitespace-nowrap rounded-lg  hover:bg-gray-800"
                >
                  ADMIN AREA
                </a>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Mobile Menu (collapsible) */}
      <nav
        className={`${
          menuOpen
            ? "max-h-[calc(100vh-80px)] opacity-100 transition-all duration-500 overflow-y-auto"
            : "max-h-0 opacity-0 transition-all duration-200"
        } overflow-clip md:hidden bg-[#d9d9d9]`}
      >
        <ul className="flex flex-col items-center p-4 min-h-[calc(100dvh-80px)] h-fit justify-center">
          {/* About VW */}
          <li className="space-y-2 text-center mb-8">
            <span className="font-medium text-xl mb-3 block">About</span>
            <ul className=" space-y-1.5 text-lg text-gray-700">
              <li>
                <a href="/contact-us">Contact Us</a>
              </li>
              <li>
                <a href="/faqs">FAQs</a>
              </li>
              <li>
                <a href="/privacy-policy">Privacy Policy</a>
              </li>
              <li>
                <a href="/shipping-and-returns">Shipping and Returns</a>
              </li>
              <li>
                <a href="/terms-of-service">Terms Of Service</a>
              </li>
              <li>
                <a href="/veneration-wear-agreement">
                  Veneration Wear Agreement
                </a>
              </li>
            </ul>
          </li>

          {/* Athletes */}
          <li className="space-y-2 text-center mb-4">
            <a href="/athletes" className="font-medium text-xl mb-3 block">Athletes</a>
          </li>

          {/* Businesses */}
          <li className="space-y-2 text-center mb-4">
            <a href="/businesses" className="font-medium text-xl mb-3 block">Businesses</a>
          </li>

          {/* Creators */}
          <li className="space-y-2 text-center mb-4">
            <a href="/creators" className="font-medium text-xl mb-3 block">Creators</a>
          </li>

          {/* CTA in mobile menu */}

          {!isAdmin && (
            <>
              <li>
                <a
                  href="/create-a-collection"
                  className="inline-block mt-3 mb-4 bg-black text-white px-5 py-3 rounded-lg uppercase hover:bg-gray-800"
                >
                  GET YOUR COLLECTION
                </a>
              </li>

              <li>
                <a href="/admin/login" className="font-medium text-xl mb-3 block">Login</a>
              </li>
            </>
          )}

          {isAdmin && (
            <>
              <li>
                <a
                  href="/admin"
                  className="inline-block mt-3 bg-black text-white px-5 py-3 rounded-lg uppercase hover:bg-gray-800"
                >
                  ADMIN AREA
                </a>
              </li>
            </>
          )}


        </ul>
      </nav>
      <SliderCart />
    </header>
  );
}
